if(!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.limit = this.dataset.limit;
      this.html = document.createElement('div');
      this.templateContent = this.querySelector('template').content.cloneNode(true);
      this.templateRootElement = this.templateContent.querySelector('.products-carousel-root');
      this.itemsContent = this.templateRootElement.querySelector('.keen-slider, .grid');
      this.intent = this.dataset.intent;

      fetch(routes.product_recommendations_url + `?product_id=${this.productId}&limit=${this.limit}&section_id=recommended_products_view&intent=${this.intent}`)
        .then(response => response.text())
        .then((text) => {
          if(text.indexOf('data-recommendation-type')>-1) {
            var html = this.itemsContent.classList.contains('grid') ? text.replaceAll('keen-slider-slide', 'grid-item') : text;
            this.style.display = ''; //removes 'display: none'
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            this.itemsContent.innerHTML = doc.querySelector('.recommended-view').innerHTML;
            this.itemsContent.querySelectorAll('.product-card').forEach(card => {
              if (this.dataset.cardsColorScheme) {
                card.classList.add('scheme', ...this.dataset.cardsColorScheme.split(' '));
              }
              if (this.dataset.cardsColorScheme==this.dataset.contentColorScheme) {
                card.classList.add('same-scheme-true');
                card.classList.remove('same-scheme-false');
              } else {
                card.classList.add('same-scheme-false');
                card.classList.remove('same-scheme-true');
              }
            });
            this.insertAdjacentElement('beforeend', this.templateRootElement);
          }
        });
    }
  }
  customElements.define('recommended-products', RecommendedProducts);
}